module.exports = __webpack_public_path__ + "img/pexels-vlad-alexandru-popa-1402787.d49f8f35.jpg";